import { Wallet } from "lucide-react";

import { useCryptoSwapLabels } from "@/modules/dashboard/crypto-swaps/hooks/useCryptoSwapLabels";
import { ColocaMoneyTransit } from "@/shared/components/motion/ColocaMoneyTransit";
import useTranslations from "@/shared/lang/useTranslations";

import { MiniCard } from "../card-load/MiniCard";

export interface CopTopUpTransitProps {
  network: string;
  last4: string;
  className?: string;
}

/**
 * A card load from pesos, as it travels: the pesos leave the COP wallet, Coloca buys USDT with them, and the
 * USDT goes over the chain to the card's deposit address.
 */
export function CopTopUpTransit({ network, last4, className }: CopTopUpTransitProps) {
  const { t } = useTranslations("cards");
  const labels = useCryptoSwapLabels();
  const chain = labels.networkShort(network);
  return (
    <ColocaMoneyTransit
      className={className}
      label={t("cop_top_up_transit_aria", { network: chain, last4 })}
      from={{ icon: <Wallet className="size-5" />, label: t("cop_top_up_transit_wallet") }}
      to={{
        icon: <MiniCard />,
        label: t("cop_top_up_transit_card"),
        caption: <span className="font-mono">•••• {last4}</span>,
      }}
      legs={[
        { rail: { kind: "fiat" }, asset: { kind: "fiat", currency: "COP" } },
        { rail: { kind: "chain", network, label: chain }, asset: { kind: "token", symbol: "USDT" } },
      ]}
    />
  );
}
